
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Camada_1","data-name":"Camada 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 52.72 56.32"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"cls-1",attrs:{"d":"M294 252.13V270M294 214.51v25.78M278.36 260.17c0 3.54-.11 7.09-.19 10.63M278.17 232q.22 8.92.24 17.85M278.17 215.28v9.29M310.11 262.22c-.05 2.6-.13 5.2-.22 7.81M310.05 227.4q.4 14.64.37 29.29M309.89 214.51v9.29","transform":"translate(-276.67 -214.51)"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M51.22.38V55.9"}})])
          )
        }
      }
    